var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.672 1.83656C14.9387 1.83656 15.1387 1.96983 15.272 2.23637C15.4054 2.43627 15.3387 2.70281 15.2054 2.90271L10.0054 9.03307V14.4971C10.0054 14.7636 9.87203 14.9635 9.67203 15.0968C9.60536 15.1634 9.47203 15.1634 9.33869 15.1634C9.20536 15.1634 9.13869 15.1634 9.07203 15.0968L6.40536 13.7641C6.13869 13.6308 6.00536 13.4309 6.00536 13.1644V9.03307L0.80536 2.90271C0.672027 2.70281 0.60536 2.43627 0.738694 2.23637C0.872027 1.96983 1.07203 1.83656 1.33869 1.83656H14.672ZM8.67203 8.83317C8.67203 8.63327 8.73869 8.5 8.80536 8.36673L13.272 3.16925H2.80536L7.20536 8.43336C7.27203 8.5 7.33869 8.6999 7.33869 8.83317V12.7646L8.67203 13.4309V8.83317Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_856_5129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.672 1.83656C14.9387 1.83656 15.1387 1.96983 15.272 2.23637C15.4054 2.43627 15.3387 2.70281 15.2054 2.90271L10.0054 9.03307V14.4971C10.0054 14.7636 9.87203 14.9635 9.67203 15.0968C9.60536 15.1634 9.47203 15.1634 9.33869 15.1634C9.20536 15.1634 9.13869 15.1634 9.07203 15.0968L6.40536 13.7641C6.13869 13.6308 6.00536 13.4309 6.00536 13.1644V9.03307L0.80536 2.90271C0.672027 2.70281 0.60536 2.43627 0.738694 2.23637C0.872027 1.96983 1.07203 1.83656 1.33869 1.83656H14.672ZM8.67203 8.83317C8.67203 8.63327 8.73869 8.5 8.80536 8.36673L13.272 3.16925H2.80536L7.20536 8.43336C7.27203 8.5 7.33869 8.6999 7.33869 8.83317V12.7646L8.67203 13.4309V8.83317Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_856_5129)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.503876,
    width: 16,
    height: 15.9922,
    fill: "#161616"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.0ae2cd2cb143d8225bb3aa054871ba87.svg";
export { ForwardRef as ReactComponent };